export const serializeMessageForBackend = (message) => {
  if (!message || typeof message !== 'object') {
    return null;
  }

  const payload = {
    id: message.id,
    role: message.role,
    text: message.text || '',
  };

  if (message.isDualMode !== undefined) {
    payload.isDualMode = message.isDualMode;
  }
  if (message.dualModeType) {
    payload.dualModeType = message.dualModeType;
  }
  if (message.modelUsed) {
    payload.modelUsed = message.modelUsed;
  }

  if (Array.isArray(message.attachments) && message.attachments.length > 0) {
    payload.attachments = message.attachments.map((attachment) => ({
      id: attachment.id,
      type: attachment.type,
      name: attachment.name,
      url: attachment.url,
      storagePath: attachment.storagePath,
      fileUri: attachment.fileUri,
      mimeType: attachment.mimeType,
      size: attachment.size,
    }));
  }

  return payload;
};
